module.exports = __webpack_public_path__ + "img/5-img-copy.c43b7a16.jpg";